import React from 'react';
import PublicLayout from '../components/public/PublicLayout';
import { Package, Heart, TrendingUp, Users } from 'lucide-react';

const EquipmentResourcesPage = () => {
  return (
    <PublicLayout>
      <div className="py-5" style={{ background: 'linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)' }}>
        <div className="container">
          {/* Header */}
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8">
              <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4" 
                style={{ width: '80px', height: '80px', backgroundColor: '#6B8E23' }}>
                <Package className="text-white" size={40} />
              </div>
              <h1 className="display-4 fw-bold text-dark mb-3">Equipment & Resource Support</h1>
              <p className="lead text-muted">
                Providing essential equipment and resources to healthcare facilities across Africa
              </p>
            </div>
          </div>

          {/* Main Content */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10">
              <div className="card shadow border-0">
                <div className="card-body p-4 p-lg-5">
                  <h2 className="h3 fw-bold text-dark mb-4">Our Equipment Support Program</h2>
                  <p className="text-muted mb-4">
                    ARCA works to ensure that healthcare facilities across Africa have access to essential 
                    respiratory care equipment and resources. Through partnerships with manufacturers, donors, 
                    and international organizations, we facilitate the distribution of quality equipment to 
                    facilities in need.
                  </p>

                  <h3 className="h4 fw-bold text-dark mb-3">Equipment We Provide</h3>
                  <ul className="list-unstyled mb-4">
                    <li className="mb-3">
                      <i className="fas fa-check-circle me-2" style={{ color: '#6B8E23' }}></i>
                      <strong>Ventilators & Respiratory Support:</strong> Mechanical ventilators, oxygen 
                      concentrators, and CPAP/BiPAP devices
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle me-2" style={{ color: '#6B8E23' }}></i>
                      <strong>Monitoring Equipment:</strong> Pulse oximeters, capnographs, and 
                      respiratory monitoring systems
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle me-2" style={{ color: '#6B8E23' }}></i>
                      <strong>Airway Management:</strong> Intubation equipment, suction devices, 
                      and airway management tools
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle me-2" style={{ color: '#6B8E23' }}></i>
                      <strong>Personal Protective Equipment:</strong> Masks, gloves, gowns, and 
                      other protective gear for respiratory care professionals
                    </li>
                  </ul>

                  <h3 className="h4 fw-bold text-dark mb-3">How We Support Facilities</h3>
                  <div className="row g-3 mb-4">
                    <div className="col-md-6">
                      <div className="d-flex align-items-start">
                        <div className="flex-shrink-0">
                          <i className="fas fa-shipping-fast fa-2x me-3" style={{ color: '#6B8E23' }}></i>
                        </div>
                        <div>
                          <h5 className="fw-bold">Equipment Donation</h5>
                          <p className="text-muted mb-0">Facilitating donations of new and refurbished equipment</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex align-items-start">
                        <div className="flex-shrink-0">
                          <i className="fas fa-tools fa-2x me-3" style={{ color: '#6B8E23' }}></i>
                        </div>
                        <div>
                          <h5 className="fw-bold">Maintenance Support</h5>
                          <p className="text-muted mb-0">Training and support for equipment maintenance</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex align-items-start">
                        <div className="flex-shrink-0">
                          <i className="fas fa-graduation-cap fa-2x me-3" style={{ color: '#6B8E23' }}></i>
                        </div>
                        <div>
                          <h5 className="fw-bold">Equipment Training</h5>
                          <p className="text-muted mb-0">Training healthcare workers on proper equipment use</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex align-items-start">
                        <div className="flex-shrink-0">
                          <i className="fas fa-handshake fa-2x me-3" style={{ color: '#6B8E23' }}></i>
                        </div>
                        <div>
                          <h5 className="fw-bold">Partnership Building</h5>
                          <p className="text-muted mb-0">Connecting facilities with equipment suppliers</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="alert" style={{ backgroundColor: '#fff3cd', borderColor: '#6B8E23', color: '#664d03' }}>
                    <strong>Need Equipment?</strong> If your facility needs respiratory care equipment, 
                    please contact us to discuss your requirements and eligibility for our support programs.
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Get Involved Section */}
          <div className="row g-4">
            <div className="col-md-4">
              <div className="card h-100 shadow-sm" style={{ borderColor: '#6B8E23', borderWidth: '2px' }}>
                <div className="card-body text-center p-4">
                  <Heart className="mb-3" size={48} style={{ color: '#6B8E23' }} />
                  <h5 className="fw-bold mb-2">Donate Equipment</h5>
                  <p className="text-muted mb-3">Help us provide equipment to facilities in need</p>
                  <a href="/get-involved/donate" className="btn fw-bold" style={{ backgroundColor: '#6B8E23', color: 'white' }}>Donate</a>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card h-100 shadow-sm" style={{ borderColor: '#6B8E23', borderWidth: '2px' }}>
                <div className="card-body text-center p-4">
                  <Users className="mb-3" size={48} style={{ color: '#6B8E23' }} />
                  <h5 className="fw-bold mb-2">Partner With Us</h5>
                  <p className="text-muted mb-3">Become an equipment partner or sponsor</p>
                  <a href="/get-involved/partner" className="btn fw-bold" style={{ backgroundColor: '#6B8E23', color: 'white' }}>Partner</a>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card h-100 shadow-sm" style={{ borderColor: '#6B8E23', borderWidth: '2px' }}>
                <div className="card-body text-center p-4">
                  <TrendingUp className="mb-3" size={48} style={{ color: '#6B8E23' }} />
                  <h5 className="fw-bold mb-2">Request Support</h5>
                  <p className="text-muted mb-3">Apply for equipment support for your facility</p>
                  <a href="/contact" className="btn fw-bold" style={{ backgroundColor: '#6B8E23', color: 'white' }}>Apply Now</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default EquipmentResourcesPage;
